import { TypographyVariantsOptions } from '@mui/material/styles';

export const typography: TypographyVariantsOptions = {
  fontFamily:
    // eslint-disable-next-line max-len -- many fallbacks
    '-apple-system, system-ui, "Segoe UI", Roboto, Noto, Oxygen-Sans, Ubuntu, Cantrell, "Helvetica Neue", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
  fontWeightBold: 700,
  h1: {
    fontFamily:
      // eslint-disable-next-line max-len -- many fallbacks
      '-apple-system, system-ui, "Segoe UI", Roboto, Noto, Oxygen-Sans, Ubuntu, Cantrell, "Helvetica Neue", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    fontWeight: 700,
    fontSize: '2.4rem',
    lineHeight: 1.4,
  },
  h2: {
    fontFamily:
      // eslint-disable-next-line max-len -- many fallbacks
      '-apple-system, system-ui, "Segoe UI", Roboto, Noto, Oxygen-Sans, Ubuntu, Cantrell, "Helvetica Neue", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    fontWeight: 700,
    fontSize: '2.2rem',
    lineHeight: 1.4,
  },
  h3: {
    fontFamily:
      // eslint-disable-next-line max-len -- many fallbacks
      '-apple-system, system-ui, "Segoe UI", Roboto, Noto, Oxygen-Sans, Ubuntu, Cantrell, "Helvetica Neue", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    fontWeight: 700,
    fontSize: '2rem',
    lineHeight: 1.4,
  },
  h4: {
    fontFamily:
      // eslint-disable-next-line max-len -- many fallbacks
      '-apple-system, system-ui, "Segoe UI", Roboto, Noto, Oxygen-Sans, Ubuntu, Cantrell, "Helvetica Neue", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    fontWeight: 700,
    fontSize: '1.8rem',
    lineHeight: 1.4,
  },
  h5: {
    fontFamily:
      // eslint-disable-next-line max-len -- many fallbacks
      '-apple-system, system-ui, "Segoe UI", Roboto, Noto, Oxygen-Sans, Ubuntu, Cantrell, "Helvetica Neue", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    fontWeight: 700,
    fontSize: '1.6rem',
    lineHeight: 1.5,
  },
  h6: {
    fontFamily:
      // eslint-disable-next-line max-len -- many fallbacks
      '-apple-system, system-ui, "Segoe UI", Roboto, Noto, Oxygen-Sans, Ubuntu, Cantrell, "Helvetica Neue", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    fontWeight: 700,
    fontSize: '1.4rem',
    lineHeight: 1.4,
  },
  subtitle1: {
    fontFamily:
      // eslint-disable-next-line max-len -- many fallbacks
      '-apple-system, system-ui, "Segoe UI", Roboto, Noto, Oxygen-Sans, Ubuntu, Cantrell, "Helvetica Neue", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    fontWeight: 600,
    fontSize: '1.6rem',
    lineHeight: 1.5,
  },
  subtitle2: {
    fontFamily:
      // eslint-disable-next-line max-len -- many fallbacks
      '-apple-system, system-ui, "Segoe UI", Roboto, Noto, Oxygen-Sans, Ubuntu, Cantrell, "Helvetica Neue", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    fontWeight: 600,
    fontSize: '1.4rem',
    lineHeight: 1.4,
  },
  body1: {
    fontFamily:
      // eslint-disable-next-line max-len -- many fallbacks
      '-apple-system, system-ui, "Segoe UI", Roboto, Noto, Oxygen-Sans, Ubuntu, Cantrell, "Helvetica Neue", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    fontWeight: 400,
    fontSize: '1.6rem',
    lineHeight: 1.5,
  },
  body2: {
    fontFamily:
      // eslint-disable-next-line max-len -- many fallbacks
      '-apple-system, system-ui, "Segoe UI", Roboto, Noto, Oxygen-Sans, Ubuntu, Cantrell, "Helvetica Neue", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    fontWeight: 400,
    fontSize: '1.4rem',
    lineHeight: 1.4,
  },
  button: {
    fontFamily:
      // eslint-disable-next-line max-len -- many fallbacks
      '-apple-system, system-ui, "Segoe UI", Roboto, Noto, Oxygen-Sans, Ubuntu, Cantrell, "Helvetica Neue", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    fontWeight: 600,
    fontSize: '1.4rem',
    lineHeight: 1.4,
    textTransform: 'initial',
  },
  buttonSmall: {
    fontFamily:
      // eslint-disable-next-line max-len -- many fallbacks
      '-apple-system, system-ui, "Segoe UI", Roboto, Noto, Oxygen-Sans, Ubuntu, Cantrell, "Helvetica Neue", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    fontWeight: 600,
    fontSize: '1.2rem',
    lineHeight: 1.5,
  },
  buttonLarge: {
    fontFamily:
      // eslint-disable-next-line max-len -- many fallbacks
      '-apple-system, system-ui, "Segoe UI", Roboto, Noto, Oxygen-Sans, Ubuntu, Cantrell, "Helvetica Neue", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    fontWeight: 600,
    fontSize: '1.4rem',
    lineHeight: 1.4,
  },
  overline: {
    fontFamily:
      // eslint-disable-next-line max-len -- many fallbacks
      '-apple-system, system-ui, "Segoe UI", Roboto, Noto, Oxygen-Sans, Ubuntu, Cantrell, "Helvetica Neue", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    fontWeight: 400,
    fontSize: '1.2rem',
    lineHeight: 1.5,
    textTransform: 'initial',
  },
  caption: {
    fontFamily:
      // eslint-disable-next-line max-len -- many fallbacks
      '-apple-system, system-ui, "Segoe UI", Roboto, Noto, Oxygen-Sans, Ubuntu, Cantrell, "Helvetica Neue", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    fontWeight: 500,
    fontSize: '1.2rem',
    lineHeight: 1.5,
  },
};
